import { render, staticRenderFns } from "./LegalBasisView.vue?vue&type=template&id=8b4a3570&"
import script from "./LegalBasisView.vue?vue&type=script&lang=js&"
export * from "./LegalBasisView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports